import cx from 'classnames';
import PropTypes from 'prop-types';

import { ResourceThumbnailTooltip } from 'src/components/ResourceThumbnailTooltip';
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';
import { PROMPT_ACTION } from 'src/data/prompt';

import { BaseMenuItem } from '../BaseMenuItem';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  onAction: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
};

export const MenuItemImage = ({ className, item, onAction }) => {
  const styles = useStyles();

  const handleClick = () => {
    onAction(PROMPT_ACTION.insertFileResource, { resource: item.resource });
  };

  const handleTooltipClick = () => {
    onAction(PROMPT_ACTION.openResourceInNewTab, { resource: item.resource });
  };

  return (
    <BaseMenuItem
      className={cx(styles.root, className)}
      item={item}
      onClick={handleClick}
    >
      <ResourceThumbnailTooltip
        placement="bottom-start"
        thumbnailUrl={item.resource?.file?.thumbnailUrl}
        onClick={handleTooltipClick}
        label={item.label}
        interactive
      >
        <div
          className={styles.image}
          style={{
            backgroundImage: 'url("' + item.resource?.file?.thumbnailUrl + '")',
          }}
        />
      </ResourceThumbnailTooltip>

      {item.label && (
        <TruncatedTypography
          className={styles.label}
          variant={TYPOGRAPHY_VARIANT.regular14}
        >
          {item.label}
        </TruncatedTypography>
      )}
    </BaseMenuItem>
  );
};

MenuItemImage.propTypes = propTypes;
MenuItemImage.defaultProps = defaultProps;
